<h2><ng-content></ng-content></h2>
